import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/i18n'
import MainContainer from '@/containers/Main.vue'
import LandingContainer from '@/containers/Landing'
import Kitchen from '@/views/Kitchen.vue'
import Error404 from '@/views/Error404.vue'
import LandingPage from '@/views/LandingPage'
import Home from '@/views/Home.vue'
import Collection from '@/views/Collection.vue'
import Product from '@/views/Product'
import Products from '@/views/Products.vue'
import Terms from '@/views/Terms.vue'
import ContactUs from '@/views/ContactUs.vue'
import ActivatedSuccessfully from '@/views/ActivatedSuccessfully.vue'
import SendActivationLink from '@/views/SendActivationLink.vue'
import Register from '@/views/Register.vue'
import Login from '@/views/Login.vue'
import SendOtpActivation from '@/views/SendOtpActivation.vue'
import UserProfile from '@/views/UserProfile.vue'
import BuySubscriptionFactor from '@/views/BuySubscriptionFactor.vue'
import BuySubscription from '@/views/BuySubscription.vue'
import ChargeWalletFactor from '@/views/ChargeWalletFactor.vue'
import SuccessfulSubscriptionPayment from '@/views/SuccessfulSubscriptionPayment.vue'
import FailedPayment from '@/views/FailedPayment.vue'
import VasSubscription from '@/views/VasSubscription.vue'
import Play from '@/views/Play.vue'
import PaymentCallback from '@/views/PaymentCallback.vue'
import SuccessfulChargeWalletPayment from '@/views/SuccessfulChargeWalletPayment'
import LoginRegister from '@/views/LoginRegister'
import Genre from '@/views/Genre'
import Genres from '@/views/Genres'
import SendCredential from '@/views/SendCredential'
import CheckSubscription from '@/views/CheckSubscription'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: '404',
      component: Error404,
      meta: {
        title: i18n.t('messages.404')
      }
    },
    {
      path: '/landing',
      name: 'landing',
      component: LandingContainer,
      children: [
        {
          path: ':id/:userUniqueIdentifier?/:refCode?',
          name: 'landing-page',
          component: LandingPage
        }
      ]
    },
    {
      path: '/',
      name: 'portal',
      component: MainContainer,
      children: [
        {
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: '/collection/:id',
          name: 'CollectionDetails',
          component: Collection
        },
        {
          path: '/genre/:id',
          name: 'GenreDetails',
          component: Genre
        },
        {
          path: '/products',
          name: 'products',
          component: Products
        },
        {
          path: '/product/:id',
          name: 'ProductDetails',
          component: Product
        },
        {
          path: '/termsandconditions',
          name: 'terms',
          component: Terms
        },
        {
          path: '/contactus',
          name: 'contact-us',
          component: ContactUs
        },
        {
          path: '/activatedsuccessfully',
          name: 'activatedSuccessfully',
          component: ActivatedSuccessfully
        },
        {
          path: '/sendactivationlink',
          name: 'sendActivationLink',
          component: SendActivationLink
        },
        {
          path: '/register',
          name: 'register',
          component: Register
        },
        {
          path: '/login',
          name: 'login',
          component: LoginRegister
        },
        {
          path: '/about',
          name: 'about',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
          path: '/sendotpactivation',
          name: 'sendOtpActivation',
          component: SendOtpActivation
        },
        {
          path: '/buysubscription',
          name: 'buysubscription',
          component: BuySubscription
        },
        {
          path: '/profile',
          name: 'profile',
          component: UserProfile
        },
        {
          path: '/buysubscriptionfactor',
          name: 'buySubscriptionFactor',
          component: BuySubscriptionFactor
        },
        {
          path: '/chargewalletfactor',
          name: 'chargeWalletFactor',
          component: ChargeWalletFactor
        },
        {
          path: '/successfulsubscriptionpayment',
          name: 'successfulSubscriptionPayment',
          component: SuccessfulSubscriptionPayment
        },
        {
          path: 'failedpayment',
          name: 'failedPayment',
          component: FailedPayment
        },
        {
          path: 'vassubscription',
          name: 'vasSubscription',
          component: VasSubscription
        },
        {
          path: '/play/:id',
          name: 'play',
          component: Play
        },
        {
          path: '/paymentcallback',
          name: 'paymentCallback',
          component: PaymentCallback
        },
        {
          path: '/successfulchargewalletpayment',
          name: 'successfulChargeWalletPayment',
          component: SuccessfulChargeWalletPayment
        },
        {
          path: '/loginregister',
          name: 'loginregister',
          component: LoginRegister
        },
        {
          path: '/genres',
          name: 'genres',
          component: Genres
        },
        {
          path: '/send-credential',
          name: 'sendCredential',
          component: SendCredential
        },
        {
          path: '/check-subscription/:code',
          name: 'checkSubscription',
          component: CheckSubscription
        }
      ]
    }
    // {
    // path: '/kitchen',
    // name: 'kitchen',
    // component: Kitchen
    // }
  ]
})
